module.exports = __webpack_public_path__ + "img/amirkabir.b59a5fa.png";